import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CanActivateGuard } from './guards/canActivate.guard';
import { isAuthenticatedGuard } from './guards/isAuthenticated.guard';
import { AdministracionComponent } from './5.admin/administracion/administracion.component';
import { CanalDatosComponent } from './5.admin/canal-datos/canal-datos.component';
import { ProductListComponent } from './5.admin/product-list/product-list.component';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { SubcanalDatosComponent } from './5.admin/subcanal-datos/subcanal-datos.component';
import { CanalInternoComponent } from './7.canal-interno/canal-interno/canal-interno.component';
import { ChannelHierarchyComponent } from './5.admin/channel-hierarchy/channel-hierarchy/channel-hierarchy.component';
import { adminAccessGuard } from './guards/admin-access.guard';
import { isLoggedInAndAdmin, isLoggedInAndMasterValidator, isLoggedInAndNotAdmin } from './guards/redirect.matchers';
import { notAllowedRolesGuard } from './guards/notAllowedRoles.guard';
import { homeRedirectGuard } from './guards/home-redirect-guard';


const routes: Routes = [
   // Redirección inicial (AHORA contempla MASTER_VALIDATOR)
  // { path: '', pathMatch: 'full', canMatch: [isLoggedInAndAdmin], redirectTo: 'admin' },
  // { path: '', pathMatch: 'full', canMatch: [isLoggedInAndMasterValidator], redirectTo: 'contracts' },
  // { path: '', pathMatch: 'full', canMatch: [isLoggedInAndNotAdmin], redirectTo: 'category' },
  // { path: '', pathMatch: 'full', redirectTo: 'login' },
  {
    path: '',
    pathMatch: 'full',
    canActivate: [homeRedirectGuard],
    children: []
  },
  // Login
  {
    path: 'login',
    canActivate: [isAuthenticatedGuard],
    loadChildren: () => import('./1.login/login.module').then(m => m.LoginModule)
  },

  // Módulos protegidos (usuarios autenticados)
  {
    path: 'category',
    canActivate: [CanActivateGuard, notAllowedRolesGuard],
    loadChildren: () => import('./2.category/category.module').then(m => m.CategoryModule)
  },
  {
    path: 'hiring',
    canActivate: [CanActivateGuard, notAllowedRolesGuard],
    loadChildren: () => import('./3.hiring/hiring.module').then(m => m.HiringModule)
  },

  // Todos los usuarios
  {
    path: 'contracts',
    canActivate: [CanActivateGuard],
    loadChildren: () => import('./4.contracts/contracts.module').then(m => m.ContractsModule)
  },

  {
    path: 'sips',
    canActivate: [CanActivateGuard],
    loadChildren: () => import('./6.sips/sips.module').then(m => m.SipsModule)
  },
  {
    path: 'scoring',
    canActivate: [CanActivateGuard],
    loadChildren: () => import('./8.scoring/scoring.module').then(m => m.ScoringModule)
  },
  {
    path: 'customers',
    canActivate: [CanActivateGuard],
    loadChildren: () => import('./9.Customers/customers.module').then(m => m.CustomersModule)
  },
  {
    path: 'production-management',
    canActivate: [CanActivateGuard],
    loadChildren: () => import('./10.production-management/production-management.module').then(m => m.ProductionManagementModule)
  },
  {
    path: 'p0-consult',
    canActivate: [CanActivateGuard],
    loadChildren: () => import('./12.p0-consult/p0-consult.module').then(m => m.P0ConsultModule)
  },
  // gestion operativa
  {
    path: 'operational-management',
    canActivate: [CanActivateGuard],
    loadChildren: () => import('./13.gestion-operativa/gestion-operativa.module').then(m => m.GestionOperativaModule)
  },

  // Admin-only

  {
    path: '',
    canActivate: [CanActivateGuard, adminAccessGuard],
    children: [
      { path: 'admin', component: AdministracionComponent },
      { path: 'canal-interno', component: CanalInternoComponent },
      { path: 'organizational-chart', component: ChannelHierarchyComponent },
      { path: 'channelDetail', component: CanalDatosComponent },
      { path: 'subChannelDetail', component: SubcanalDatosComponent },
      { path: 'productList', component: ProductListComponent },
      {
        path: 'brands',
        canActivate: [CanActivateGuard],
        loadChildren: () => import('./11.Brands/brands.module').then(m => m.BrandsModule)
      },
    ]
  },

  // Fallback
  { path: '**', redirectTo: 'login' }

];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'top'
  })],
  exports: [RouterModule],
  providers: [
    { provide: LocationStrategy, useClass: HashLocationStrategy }
  ]
})
export class AppRoutingModule { }
